import ContactRelationForm from '@contacts/components/forms/contact-relation-form/contact-relation-form.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-family-form',
  components: {
    'bpc-contact-relation-form': ContactRelationForm,
  },
})
export default class ProfileFamilyForm extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
